<template>
  <div>
    <div class="top">
      <div class="back">
        <img
          @click="backPage"
          class="add-img"
          src="@/assets/images/back.jpg"
        />权限管理
      </div>
      <div class="search">
        <el-button size="medium" @click="rest" style="margin-right: 4px">重置</el-button>
        <el-button :loading="loadingShow" v-repeatClick size="medium"  v-if="codeData.indexOf('130') != -1" @click="submit" type="primary">保存</el-button>
      </div>
    </div>
    <a-spin :spinning="loading">
      <div class="content">
        <p class="role-name">当前角色: {{name}}</p>
        <div :style="{height:height}" class="deliverySetting">
          <div v-for="(item, index) in arrayData" class="deliverySetting-table">
            <div class="table-head">
              <div class="selection">
                <el-checkbox
                  :indeterminate="indeterminate[index]"
                  v-model="ischeckAll[index]"
                  @change="
                    (e) => {
                      handleCheckAllChange(e, index);
                    }
                  "
                ></el-checkbox>
              </div>
              <div class="width185">{{ item.menuName }}</div>
            </div>
            <div class="table-box">
              <div
                class="table-body"
                v-if="item.children"
                v-for="(partition, partitionIndex) in item.children"
                :key="partitionIndex"
              >
                <div class="box-one">
                  <div class="selection">
                    <p>
                      <el-checkbox
                        :indeterminate="partition.indeterminate"
                        v-model="partition.selected"
                        @change="
                          handleCheckedCountryAllChange(
                            index,
                            partitionIndex,
                            $event
                          )
                        "
                        :key="partitionIndex"
                      ></el-checkbox>
                    </p>
                  </div>
                  <div class="width185">
                    <p>{{ partition.menuName }}</p>
                  </div>
                </div>
                <div class="width265">
                  <el-checkbox
                    v-for="country in partition.children"
                    v-model="country.selected"
                    @change="
                      handleCheckedCountryChange(
                        index,
                        partitionIndex,
                        country.id,
                        $event
                      )
                    "
                    :label="country"
                    :key="country.id"
                    >{{ country.menuName }}</el-checkbox
                  >
                </div>
              </div>
              <div v-if="!item.children" class="table-body">
                <div class="box-emty-one"></div>
                <div class="box-emty-two"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
import { listTree, roleMenuList, saveRoleMenu } from "./role_management";
import { message } from "ant-design-vue";
export default {
  name: "deliverySetting",
  components: {},
  props: {},
  data() {
    return {
      arrayData: [],
      ischeckAll: [],
      indeterminate: [],
      id: "",
      threeArray: [],
      loading: false,
      codeData:[],
      name:'',
      height:0,
      loadingShow:false,
    };
  },
  computed: {},
  created() {
    this.id = this.$route.query.id;
    this.name = this.$route.query.name;
  },
  mounted() {
    this.getList();
    this.arrayData.forEach((element, index) => {
      this.ischeckAll[index] = false;
      this.indeterminate[index] = false;
    });
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    this.height = (document.documentElement.clientHeight -249)+'px';
    window.onresize = () => {
      return (() => {
         this.height = (document.documentElement.clientHeight -249)+'px';
      })();
    };
  },
  methods: {
    getList() {
      this.loading = true;
      listTree({ id: this.id }).then((res) => {
        if (res.code == 0) {
          roleMenuList({ id: this.id }).then((resTwo) => {
            if (res.code == 0) {
              this.loading = false;
              this.loadingShow = false;
               let arrayList = [];
              if(resTwo.data){
                arrayList  = this.takeOut(resTwo.data);
               this.processingData(res, arrayList);
              }else{
                 this.processingData(res, arrayList);
              }
              
            }
          });
        }
      });
    },
    // 取出存在的权限id
    takeOut(array) {
      let arrarIds = [];
      array.forEach((element, key) => {
        arrarIds.push(element.id);
        if (element.children) {
          element.children.forEach((elementTwo, index) => {
            arrarIds.push(elementTwo.id);
            if (elementTwo.children) {
              elementTwo.children.forEach((elementThree, indexThree) => {
                arrarIds.push(elementThree.id);
              });
            }
          });
        }
      });
      return arrarIds;
    },

    // 对第三级选择添加字段
    processingData(res, arrayList) {
      // 对一级数据进行处理
      let array = [];
      res.data.forEach((element) => {
        if (!element.children) {
          array.unshift(element);
        } else {
          array.push(element);
        }
      });
      if(arrayList.length > 0){
        array = this.handleThreeList(array, arrayList);
      }
      this.arrayData = JSON.parse(JSON.stringify(array));
      this.intSelect();
    },

    // 处理三级默认选中
    handleThreeList(array, arrayList) {
      // 添加字段
      array.forEach((element, key) => {
        if (element.children) {
          element.children.forEach((elementTwo, index) => {
            if (elementTwo.children) {
              this.threeArray[key + "-" + index] = [];
              elementTwo.children.forEach((elementThree, indexThree) => {
                if (arrayList.indexOf(elementThree.id) != -1) {
                  elementThree.selected = true;
                  this.threeArray[key + "-" + index].push(elementThree.id);
                } else {
                  elementThree.selected = false;
                }
              });
            }
          });
        }
      });
      this.secondLevel(array, arrayList);
      return array;
    },

    // 重置数据
    rest() {
      this.arrayData.forEach((element,key) => {
        element.selected = false;
         this.ischeckAll[key] = false;
        this.indeterminate[key] = false;
        if (element.children) {
          element.children.forEach((elementTwo) => {
            elementTwo.selected = false;
            elementTwo.indeterminate = false;
            if (elementTwo.children) {
              elementTwo.children.forEach((elementThree) => {
                elementThree.selected = false;
              });
            }
          });
        }
      });
    },
    // 处理一级，二级默认选中
    secondLevel(array, arrayList) {
      array.forEach((element, key) => {
        if (element.children) {
           let twoArray = [];
          element.children.forEach((elementTwo, index) => {
            if (elementTwo.children) {
              if (this.threeArray[key + "-" + index].length > 0) {
                elementTwo.selected = true;
                elementTwo.indeterminate = true;
                this.ischeckAll[key] = true;
                this.indeterminate[key] = true;
              }
              if (
                elementTwo.children.length ==
                this.threeArray[key + "-" + index].length
              ) {
                elementTwo.selected = true;
                elementTwo.indeterminate = false;
                twoArray.push(elementTwo.indeterminate)
              }else{
                elementTwo.selected = false;
              }
            }
          });
          if(element.children.length == twoArray.length){
               this.ischeckAll[key] = true;
                this.indeterminate[key] = false;
          }else{
            this.ischeckAll[key] = false;
          }
        } else {
          if (arrayList.indexOf(element.id) != -1) {
            this.ischeckAll[key] = true;
            this.indeterminate[key] = false;
          }
        }
      });
    },

    intSelect() {
      this.arrayData.forEach((element, index) => {
        if (element.selected) {
          this.getIsCheckAll(index);
        }
      });
    },
    backPage() {
      this.$router.push("/index/userManagement/role_management");
    },
    submit() {
      this.loadingShow = true;
      this.loading = true;
      let selectIds = [];
      this.arrayData.forEach((element, index) => {
        if (element.children) {
          element.children.forEach((elementTwo, indexTwo) => {
            if(elementTwo.children){
              elementTwo.children.forEach((elementThree, indexThree) => {
              if (elementThree.selected) {
                selectIds.push(element.id);
                selectIds.push(elementTwo.id);
                selectIds.push(elementThree.id);
              }
            });
            }
          });
        } else {
          if (this.ischeckAll[index]) {
            selectIds.push(element.id);
          }
        }
      });
      // 对数组去除重复
      selectIds = this.duplicate(selectIds);
      this.sumitData(selectIds);
    },
    // 保存数据
    sumitData(selectIds) {
      saveRoleMenu({
        id: this.id,
        idList: selectIds,
      }).then((res) => {
        if (res.code == 0) {
          message.success("保存成功");
          this.getList();
        }
      });
    },
    duplicate(arr) {
      let newsArr = [];
      for (let i = 0; i < arr.length; i++) {
        if (newsArr.indexOf(arr[i]) === -1) {
          newsArr.push(arr[i]);
        }
      }
      return newsArr;
    },
    handleCheckAllChange(e, index) {
      //一级change事件
      console.log(e,'sssssssss')
      this.ischeckAll[index] = e;
      this.indeterminate[index] = false;
      this.arrayData[index].selected = e;
      for (
        var i = 0, len = this.arrayData[index].children.length;
        i < len;
        i++
      ) {
        //二级全选反选
        this.arrayData[index].children[i].selected = e;
        this.arrayData[index].children[i].indeterminate = false; //去掉二级不确定状态
        for (
          var j = 0, len1 = this.arrayData[index].children[i].children.length;
          j < len1;
          j++
        ) {
          //三级全选反选
          this.arrayData[index].children[i].children[j].selected = e;
        }
      }
    },
    handleCheckedCountryAllChange(parIndex, index, e) {
      //二级change事件
      this.arrayData[parIndex].children[index].selected = e; //二级勾选后，子级全部勾选或者取消
      this.arrayData[parIndex].children[index].indeterminate = false; //去掉二级不确定状态
      var childrenArray = this.arrayData[parIndex].children[index].children;
      if (childrenArray)
        for (var i = 0, len = childrenArray.length; i < len; i++)
          childrenArray[i].selected = e;
      this.getIsCheckAll(parIndex);
    },
    handleCheckedCountryChange(parIndex, topIndex, sonId, e) {
      //三级change事件
      var childrenArray = this.arrayData[parIndex].children[topIndex].children;
      var tickCount = 0,
        unTickCount = 0,
        len = childrenArray.length;
      for (var i = 0; i < len; i++) {
        if (sonId == childrenArray[i].id) childrenArray[i].selected = e;
        if (childrenArray[i].selected == true) tickCount++;
        if (childrenArray[i].selected == false) unTickCount++;
      }
      if (tickCount == len) {
        //三级级全勾选
        this.arrayData[parIndex].children[topIndex].selected = true;
        this.arrayData[parIndex].children[topIndex].indeterminate = false;
      } else if (unTickCount == len) {
        //三级级全不勾选
        this.arrayData[parIndex].children[topIndex].selected = false;
        this.arrayData[parIndex].children[topIndex].indeterminate = false;
      } else {
        this.arrayData[parIndex].children[topIndex].selected = false;
        this.arrayData[parIndex].children[topIndex].indeterminate = true; //添加二级不确定状态
      }
      this.getIsCheckAll(parIndex);
    },
    getIsCheckAll(index) {
      var tickCount = 0,
        unTickCount = 0,
        indeterminateCount = 0,
        ArrLength = this.arrayData[index].children.length;

      for (var j = 0; j < ArrLength; j++) {
        //全选checkbox状态
        if (this.arrayData[index].children[j].selected == true) tickCount++;
        if (this.arrayData[index].children[j].selected == false) unTickCount++;
        if (this.arrayData[index].children[j].indeterminate == true)
          indeterminateCount++;
      }
      if (tickCount == ArrLength) {
        //二级全勾选
        this.ischeckAll[index] = true;
        this.ischeckAll = JSON.parse(JSON.stringify(this.ischeckAll));
        this.indeterminate[index] = false;
        this.indeterminate = JSON.parse(JSON.stringify(this.indeterminate));
      } else if (unTickCount == ArrLength) {
        //二级全不勾选
        this.ischeckAll[index] = false;
        this.ischeckAll = JSON.parse(JSON.stringify(this.ischeckAll));
        if (indeterminateCount > 0) {
          this.indeterminate[index] = true;
          this.indeterminate = JSON.parse(JSON.stringify(this.indeterminate));
        } else {
          this.indeterminate[index] = false;
          this.indeterminate = JSON.parse(JSON.stringify(this.indeterminate));
        }
      } else {
        this.ischeckAll[index] = false;
        this.ischeckAll = JSON.parse(JSON.stringify(this.ischeckAll));
        this.indeterminate[index] = true; //添加一级不确定状态
        this.indeterminate = JSON.parse(JSON.stringify(this.indeterminate));
      }
    },
  },
};
</script>
<style lang="less" scoped>
p {
  padding: 0;
  margin: 0;
}
.box-emty-one {
  width: 180px;
  height: 50px;
  border: solid 1px #ccc;
  border-bottom: none;
  padding: 34px 0;
  background: #f7f7f7;
}
.box-emty-two {
  width: 100%;
  height: 50px;
  border: solid 1px #ccc;
  border-bottom: none;
  border-left: none;
  padding: 34px 0;
}
.deliverySetting {
  padding: 24px;
  position: relative;
  overflow-y: auto;
  .el-table {
    thead {
      tr {
        th {
          font-size: 14px;
        }
      }
    }
    tbody {
      tr {
        td {
          vertical-align: baseline;
          p {
            line-height: 30px;
          }
          .el-checkbox-group {
            display: flex;
            flex-direction: column;
            label {
              line-height: 30px;
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  .deliverySetting-table {
    font-size: 14px;
    color: #333;
    .table-head,
    .table-body {
      display: flex;
      .selection {
        text-align: center;
        line-height: 36px;
        margin-right: 10px;
      }
      .width185 {
        //width: 185px;
      }
      .width265 {
        width: 100%;
        padding-left: 24px;
        border: solid 1px #ccc;
        border-bottom: none;
        label {
          display: inline-block;
          float: left;
          line-height: 30px;
          margin-block-start: 1em;
          margin-block-end: 1em;
          margin-inline-start: 0px;
          margin-inline-end: 0px;
          margin-right: 1em;
        }
      }
    }
    .table-head {
      align-items: center;
      border: solid 1px #ccc;
      border-right: none;
      border-bottom: none;
      width: 120px;
      display: flex;
      justify-content: center;
      //padding: 16px;
      background: #f7f7f7;
    }

    .table-body {
      &:hover {
        background-color: #f5f7fa;
      }
      p {
        line-height: 30px;
      }
    }
  }
  .deliverySetting-table:last-child {
    .table-head {
      border-bottom: solid 1px #ccc;
    }
    .table-body:last-child {
      .box-one {
        border-bottom: solid 1px #ccc;
      }
      .width265 {
        border-bottom: solid 1px #ccc;
      }
    }
  }
  .deliverySetting-btn {
    /*width: 100%;*/
    height: 59px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    top: -55px;
    right: -16px;
    z-index: 100;
    .tabs-btn {
      min-width: 90px;
      height: 34px;
      line-height: 32px;
      padding: 0 10px;
      color: #2387f7;
      border: solid 1px #4fa2ff;
      background-color: #e7f2ff;
      cursor: pointer;
      &:nth-of-type(2) {
        margin: 0 15px;
      }
      input {
        border: none;
        background: transparent;
        color: inherit;
        cursor: inherit;
        outline: none;
        margin: 0;
        padding: 0;
      }
      &:hover {
        color: #fff;
        background-color: #2387f7;
      }
    }
  }
}
.deliverySetting-table {
  display: flex;
}
.box-one {
  display: flex;
  border: solid 1px #ccc;
  border-right: none;
  border-bottom: none;
  width: 179px;
  align-items: center;
  justify-content: center;
  background: #f7f7f7;
}
.table-box {
  width: 100%;
}
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #f4f4f6 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search {
    display: flex;
  }
  .back {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }
  .add-img {
    margin-right: 5px;
    margin-top: -3px;
    cursor: pointer;
  }
}
.role-name {
  padding: 24px;
  padding-bottom: 0px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
  margin-bottom: 0px;
}
.deliverySetting-table:first-child {
  .table-head {
    border-top-left-radius: 6px;
  }
  .table-body {
    .box-emty-two {
      border-top-right-radius: 6px;
    }
    .width265 {
      border-top-right-radius: 6px;
    }
  }
}
.deliverySetting-table:last-child {
  .table-head {
    border-bottom-left-radius: 6px;
  }
  .table-body:last-child {
    .box-emty-two {
      border-bottom-right-radius: 6px;
    }
    .width265 {
      border-bottom-right-radius: 6px;
    }
  }
}
.el-button--primary {
  background: #176de6;
}
</style>